var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"border text-white uppercase font-semibold tracking-wider leading-normal",class:[
        _vm.size == 'small' ? 'text-2xs px-5 py-2' : 'text-xs px-6 py-3',
        _vm.disabled ? 'bg-gray-300 border-gray-300' : 'bg-green-warm-500 border-green-warm-500 hover:border-green-warm-600 hover:bg-green-warm-600 cursor-pointer',
    ],attrs:{"type":"button"},on:{"click":function($event){_vm.disabled ? null : _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }